<template>
  <div class="service_manage">
    <el-divider content-position="left">订单类型管理列表</el-divider>
    <el-row style="margin-bottom: 0.4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddOpenOrderReg"
          >新增订单类型</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click.native="$router.push('setting_panel')"
          >返回上一级</el-button
        >
      </el-col>
    </el-row>
    <el-table
      height="calc(100vh - 280px)"
      border
      :data="pageDataOrderReg"
      size="medium"
      style="width: 100%"
    >
      <el-table-column label="id" fixed>
        <template slot-scope="scope">
          {{ scope.row.order_reg_id }}
        </template>
      </el-table-column>
      <el-table-column label="注册类型" width="200" fixed>
        <template slot-scope="scope">
          {{ scope.row.order_reg_name }}
        </template>
      </el-table-column>
      <el-table-column label="注册分类" width="100" fixed>
        <template slot-scope="scope">
          {{ scope.row.order_cate }}
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序" width="130" fixed>
        <template slot-scope="scope">
          <el-input
            type="number"
            size="mini"
            v-model="listSort[scope.row.order_reg_id]"
            @blur="setSort(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="是否含注册" width="100">
        <template slot-scope="scope">
          {{ scope.row.order_include_reg === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含代理记账" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_agency === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含税务报到" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_tax_report === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含银行开户" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_open_bank === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含税盘托管" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_tax_plate === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含社保开户" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_secuity_open === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含公积金开户" width="140">
        <template slot-scope="scope">
          {{ scope.row.is_accum_open === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含税控代办" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_ensure_agent === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含税控托管" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_ensure_hosting === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含注册地址" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_address === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含工商变更" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_industry_change === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含税务变更" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_tax_change === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含银行变更" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_bank_change === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含社保变更" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_secuity_change === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含公积金变更" width="140">
        <template slot-scope="scope">
          {{ scope.row.is_accum_change === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含工商注销" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_industry_logout === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含税务注销" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_tax_logout === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含银行注销" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_bank_logout === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含社保注销" width="130">
        <template slot-scope="scope">
          {{ scope.row.is_secuity_logout === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含公积金注销" width="140">
        <template slot-scope="scope">
          {{ scope.row.is_accum_logout === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="是否含许可证注销" width="140">
        <template slot-scope="scope">
          {{ scope.row.is_licence_logout === 2 ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEditOrderReg(scope.$index, scope.row)">
            编辑
          </el-button>
          <el-popconfirm
            @onConfirm="handleDeleteOrderReg(scope.$index, scope.row.order_reg_id)"
            confirmButtonText="确定"
            cancelButtonText="取消"
            icon="el-icon-info"
            iconColor="red"
            title="这是一段内容确定删除吗？"
          >
            <el-button size="mini" type="danger" slot="reference"> 删除 </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!--    页码-->
    <div class="page-footer">
      <el-pagination
        class="pagination-style"
        background
        layout="total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOptionOrderReg.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOptionOrderReg.pageSize"
        :total="pageOptionOrderReg.total"
        @size-change="handleSizeChangeOrderReg"
        @current-change="handleCurrentChangeOrderReg"
      >
      </el-pagination>
    </div>
    <!--    添加-->
    <el-drawer
      title="添加"
      :visible.sync="AddDrawerOrderReg"
      :direction="direction"
      :before-close="handleClose"
      size="50%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="2" class="m-label">订单分类</el-col>
          <el-col :span="8" :offset="1">
            <el-select
              v-model="addDataOrderReg.order_cate"
              placeholder="请选择"
              :size="inputSize"
              clearable
            >
              <el-option :value="1" label="注册订单"></el-option>
              <el-option :value="2" label="套餐订单"></el-option>
              <el-option :value="3" label="单品订单"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2" :offset="2" class="m-label">订单类型</el-col>
          <el-col :span="8" :offset="1">
            <el-input
              placeholder="请输入订单类型"
              :size="inputSize"
              v-model="addDataOrderReg.order_reg_name"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">企业新设</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公司注册</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.order_include_reg" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">注册地址</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_address" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_open_bank" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">咨询与提醒</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">一对一财务咨询</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.one_to_one" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">多对一财务咨询</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.many_to_one" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">专属财务服务群</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.spec_accountant" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">短信提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.msg_attention" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">邮件提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.email_attention" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">公众号提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.public_notice" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">基础财税服务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">税务报到</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_tax_report" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_secuity_open" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_accum_open" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税盘代办</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_ensure_agent" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">初始建账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.init_build_acc" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">旧账导入</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.old_tax_import" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">企业年报公示</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.annl_show" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">年度汇算清缴</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.annl_pay" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">记账报税</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">代理记账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_agency" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">银行明细信息录入(对账单/回单)</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.bank_rec_add" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">人员工资</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.persionel_salary" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">人员工资测算</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.persionel_calculate" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">扣缴税款</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.tax_withholding" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">纳税申报</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.tax_return" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">出具财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.financial_statements" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">编制财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.add_financial_excel" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">社保托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.social_host" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">公积金托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.fund_host" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">税盘托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_ensure_hosting" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">全电发票</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.electric_invoice" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">发票管理服务</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.invoice_manage" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税控解锁</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.tax_unlock" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">凭证服务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">凭证装订</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.voucher_binding" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">凭证代存</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.voucher_save" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">凭证代存年末装订总账明细账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.total_account" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">凭证快递费</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.voucher_exp" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">智能财税</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">手机查账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.tel_seek_acc" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">客户服务端(小程序会员)</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.client_mini" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.financial_report" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务风险报告</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.tax_risk" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">许可证业务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">许可证新办</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.license_new" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">许可证变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.license_modify" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">许可证注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_licence_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">公司变更相关</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">工商变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_industry_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_tax_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_bank_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_secuity_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_accum_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">公司注销</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">工商注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_industry_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_tax_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_bank_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_secuity_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="addDataOrderReg.is_accum_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <div class="addCon">
          <el-button type="primary" size="mini" @click="handleAddOrderReg"
            >添加</el-button
          >
        </div>
      </div>
    </el-drawer>
    <!--    编辑-->
    <el-drawer
      title="编辑"
      :visible.sync="saveDrawerOrderReg"
      :direction="direction"
      :before-close="handleSaveDrawerClose"
      size="50%"
    >
      <div class="m-tabs-content">
        <el-row>
          <el-col :span="2" class="m-label">订单分类</el-col>
          <el-col :span="8" :offset="1">
            <el-select
              v-model="upDataOrderReg.order_cate"
              placeholder="请选择"
              :size="inputSize"
              clearable
            >
              <el-option :value="1" label="注册订单"></el-option>
              <el-option :value="2" label="套餐订单"></el-option>
              <el-option :value="3" label="单品订单"></el-option>
            </el-select>
          </el-col>
          <el-col :span="2" :offset="2" class="m-label">订单类型</el-col>
          <el-col :span="8" :offset="1">
            <el-input
              placeholder="请输入订单类型"
              :size="inputSize"
              v-model="upDataOrderReg.order_reg_name"
              clearable
            >
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">企业新设</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公司注册</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.order_include_reg" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">注册地址</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_address" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_open_bank" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">咨询与提醒</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">一对一财务咨询</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.one_to_one" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">多对一财务咨询</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.many_to_one" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">专属财务服务群</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.spec_accountant" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">短信提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.msg_attention" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">邮件提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.email_attention" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">公众号提醒</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.public_notice" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">基础财税服务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">税务报到</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_tax_report" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_secuity_open" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金开户</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_accum_open" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税盘代办</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_ensure_agent" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">初始建账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.init_build_acc" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">旧账导入</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.old_tax_import" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">企业年报公示</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.annl_show" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">年度汇算清缴</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.annl_pay" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">记账报税</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">代理记账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_agency" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">银行明细信息录入(对账单/回单)</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.bank_rec_add" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">人员工资</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.persionel_salary" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">人员工资测算</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.persionel_calculate" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">扣缴税款</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.tax_withholding" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">纳税申报</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.tax_return" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">出具财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.financial_statements" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">编制财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.add_financial_excel" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">社保托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.social_host" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">公积金托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.fund_host" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">税盘托管</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_ensure_hosting" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">全电发票</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.electric_invoice" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">发票管理服务</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.invoice_manage" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税控解锁</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.tax_unlock" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">凭证服务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">凭证装订</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.voucher_binding" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">凭证代存</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.voucher_save" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">凭证代存年末装订总账明细账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.total_account" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">凭证快递费</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.voucher_exp" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">智能财税</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">手机查账</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.tel_seek_acc" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">客户服务端(小程序会员)</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.client_mini" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">财务报表</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.financial_report" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务风险报告</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.tax_risk" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">许可证业务</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">许可证新办</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.license_new" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">许可证变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.license_modify" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">许可证注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_licence_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">公司变更相关</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">工商变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_industry_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_tax_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_bank_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_secuity_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金变更</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_accum_change" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-divider content-position="left">公司注销</el-divider>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">工商注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_industry_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">税务注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_tax_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">银行注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_bank_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
          <el-col :span="4" class="label-height">社保注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_secuity_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4" class="label-height">公积金注销</el-col>
          <el-col :span="8">
            <el-radio-group v-model="upDataOrderReg.is_accum_logout" size="mini">
              <el-radio :label="1" border>否</el-radio>
              <el-radio :label="2" border>是</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </div>
      <div class="addCon">
        <el-button type="primary" size="mini" @click="handleSaveOrderReg">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: "service_manage",
  data() {
    return {
      inputSize: "small",
      direction: "rtl",
      optionOrderReg: [],
      pageOptionOrderReg: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      AddDrawerOrderReg: false,
      saveDrawerOrderReg: false,
      addDataOrderReg: {
        order_cate: "",
        order_reg_name: "",
        order_include_reg: 1,
        is_agency: 1,
        is_tax_report: 1,
        is_open_bank: 1,
        is_tax_plate: 1,
        is_accum_open: 1,
        is_secuity_open: 1,
        is_ensure_agent: 1,
        is_ensure_hosting: 1,
        is_address: 1,
        is_industry_change: 1,
        is_tax_change: 1,
        is_bank_change: 1,
        is_secuity_change: 1,
        is_accum_change: 1,
        is_industry_logout: 1,
        is_tax_logout: 1,
        is_bank_logout: 1,
        is_secuity_logout: 1,
        is_accum_logout: 1,
        is_licence_logout: 1,
        one_to_one: 1,
        many_to_one: 1,
        spec_accountant: 1,
        msg_attention: 1,
        email_attention: 1,
        public_notice: 1,
        voucher_binding: 1,
        voucher_save: 1,
        total_account: 1,
        voucher_exp: 1,
        tel_seek_acc: 1,
        client_mini: 1,
        financial_report: 1,
        tax_risk: 1,
        license_new: 1,
        license_modify: 1,
        init_build_acc: 1,
        old_tax_import: 1,
        annl_show: 1,
        annl_pay: 1,
        bank_rec_add: 1,
        persionel_salary: 1,
        persionel_calculate: 1,
        tax_withholding: 1,
        tax_return: 1,
        financial_statements: 1,
        add_financial_excel: 1,
        social_host: 1,
        fund_host: 1,
        electric_invoice: 1,
        invoice_manage: 1,
        tax_unlock: 1,
      },
      upDataOrderReg: {
        index: null,
        order_cate: "",
        order_reg_id: null,
        order_reg_name: "",
        order_include_reg: 1,
        is_agency: 1,
        is_tax_report: 1,
        is_open_bank: 1,
        is_tax_plate: 1,
        is_accum_open: 1,
        is_secuity_open: 1,
        is_ensure_agent: 1,
        is_ensure_hosting: 1,
        is_address: 1,
        is_industry_change: 1,
        is_tax_change: 1,
        is_bank_change: 1,
        is_secuity_change: 1,
        is_accum_change: 1,
        is_industry_logout: 1,
        is_tax_logout: 1,
        is_bank_logout: 1,
        is_secuity_logout: 1,
        is_accum_logout: 1,
        is_licence_logout: 1,
        one_to_one: 1,
        many_to_one: 1,
        spec_accountant: 1,
        msg_attention: 1,
        email_attention: 1,
        public_notice: 1,
        voucher_binding: 1,
        voucher_save: 1,
        total_account: 1,
        voucher_exp: 1,
        tel_seek_acc: 1,
        client_mini: 1,
        financial_report: 1,
        tax_risk: 1,
        license_new: 1,
        license_modify: 1,
        init_build_acc: 1,
        old_tax_import: 1,
        annl_show: 1,
        annl_pay: 1,
        bank_rec_add: 1,
        persionel_salary: 1,
        persionel_calculate: 1,
        tax_withholding: 1,
        tax_return: 1,
        financial_statements: 1,
        add_financial_excel: 1,
        social_host: 1,
        fund_host: 1,
        electric_invoice: 1,
        invoice_manage: 1,
        tax_unlock: 1,
      },
      listSort: [],
    };
  },
  computed: {
    pageDataOrderReg: {
      get: function () {
        return this.optionOrderReg.slice(
          this.pageOptionOrderReg.pageSize * (this.pageOptionOrderReg.currentPage - 1),
          this.pageOptionOrderReg.pageSize * this.pageOptionOrderReg.currentPage
        );
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    // 订单类型
    getDataOrderReg() {
      this.$axios.get("/api/order_reg/reg_type_list").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.optionOrderReg = data.data;
          this.pageOptionOrderReg.total = this.optionOrderReg.length;
          this.loadSort()
        }
      });
    },
    setSort (row) {
      if (isNaN(this.listSort[row.order_reg_id])) {
        this.$message.error('排序值为数字！')
        return false
      }
      this.$axios
        .post('api/admin/order_reg_type/edit_sort', {
          order_reg_id: row.order_reg_id,
          sort: this.listSort[row.order_reg_id]
        })
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.$message.success(data.msg)
            this.getDataOrderReg()
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadSort () {
      this.optionOrderReg.map(item => {
        this.listSort[item.order_reg_id] = Number(item.sort)
      })
    },
    handleAddOpenOrderReg() {
      this.clearOrderRegData();
      this.AddDrawerOrderReg = true;
    },
    handleAddOrderReg() {
      if (!this.addDataOrderReg.order_cate) {
        this.$message.error("订单分类不能为空");
        return;
      }
      if (!this.addDataOrderReg.order_reg_name) {
        this.$message.error("订单类型不能为空");
        return;
      }
      this.$axios.post("/api/order_reg/create", this.addDataOrderReg).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.optionOrderReg.unshift(data.data);
          this.pageOptionOrderReg.total = this.optionOrderReg.length;
          this.$message.success(data.msg);
          this.AddDrawerOrderReg = false;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleEditOrderReg(index, row) {
      this.upDataOrderReg.index = index;
      this.upDataOrderReg.order_cate = row.order_cate;
      this.upDataOrderReg.order_reg_id = row.order_reg_id;
      this.upDataOrderReg.order_reg_name = row.order_reg_name;
      this.upDataOrderReg.order_include_reg = row.order_include_reg;
      this.upDataOrderReg.is_agency = row.is_agency;
      this.upDataOrderReg.is_tax_report = row.is_tax_report;
      this.upDataOrderReg.is_open_bank = row.is_open_bank;
      this.upDataOrderReg.is_tax_plate = row.is_tax_plate;
      this.upDataOrderReg.is_accum_open = row.is_accum_open;
      this.upDataOrderReg.is_secuity_open = row.is_secuity_open;
      this.upDataOrderReg.is_ensure_agent = row.is_ensure_agent;
      this.upDataOrderReg.is_ensure_hosting = row.is_ensure_hosting;
      this.upDataOrderReg.is_address = row.is_address;
      this.upDataOrderReg.is_industry_change = row.is_industry_change;
      this.upDataOrderReg.is_tax_change = row.is_tax_change;
      this.upDataOrderReg.is_bank_change = row.is_bank_change;
      this.upDataOrderReg.is_secuity_change = row.is_secuity_change;
      this.upDataOrderReg.is_accum_change = row.is_accum_change;
      this.upDataOrderReg.is_industry_logout = row.is_industry_logout;
      this.upDataOrderReg.is_tax_logout = row.is_tax_logout;
      this.upDataOrderReg.is_bank_logout = row.is_bank_logout;
      this.upDataOrderReg.is_secuity_logout = row.is_secuity_logout;
      this.upDataOrderReg.is_accum_logout = row.is_accum_logout;
      this.upDataOrderReg.is_licence_logout = row.is_licence_logout;
      this.upDataOrderReg.one_to_one = row.one_to_one;
      this.upDataOrderReg.many_to_one = row.many_to_one;
      this.upDataOrderReg.spec_accountant = row.spec_accountant;
      this.upDataOrderReg.msg_attention = row.msg_attention;
      this.upDataOrderReg.email_attention = row.email_attention;
      this.upDataOrderReg.public_notice = row.public_notice;
      this.upDataOrderReg.voucher_binding = row.voucher_binding;
      this.upDataOrderReg.voucher_save = row.voucher_save;
      this.upDataOrderReg.total_account = row.total_account;
      this.upDataOrderReg.voucher_exp = row.voucher_exp;
      this.upDataOrderReg.tel_seek_acc = row.tel_seek_acc;
      this.upDataOrderReg.client_mini = row.client_mini;
      this.upDataOrderReg.financial_report = row.financial_report;
      this.upDataOrderReg.tax_risk = row.tax_risk;
      this.upDataOrderReg.license_new = row.license_new;
      this.upDataOrderReg.license_modify = row.license_modify;
      this.upDataOrderReg.init_build_acc = row.init_build_acc;
      this.upDataOrderReg.old_tax_import = row.old_tax_import;
      this.upDataOrderReg.annl_show = row.annl_show;
      this.upDataOrderReg.annl_pay = row.annl_pay;
      this.upDataOrderReg.bank_rec_add = row.bank_rec_add;
      this.upDataOrderReg.persionel_salary = row.persionel_salary;
      this.upDataOrderReg.persionel_calculate = row.persionel_calculate;
      this.upDataOrderReg.tax_withholding = row.tax_withholding;
      this.upDataOrderReg.tax_return = row.tax_return;
      this.upDataOrderReg.financial_statements = row.financial_statements;
      this.upDataOrderReg.add_financial_excel = row.add_financial_excel;
      this.upDataOrderReg.social_host = row.social_host;
      this.upDataOrderReg.fund_host = row.fund_host;
      this.upDataOrderReg.electric_invoice = row.electric_invoice;
      this.upDataOrderReg.invoice_manage = row.invoice_manage;
      this.upDataOrderReg.tax_unlock = row.tax_unlock;
      this.saveDrawerOrderReg = true;
    },
    clearOrderRegData() {
      this.addDataOrderReg.index = null;
      this.addDataOrderReg.order_reg_id = null;
      this.addDataOrderReg.order_reg_name = "";
      this.addDataOrderReg.order_cate = "";
      this.addDataOrderReg.order_include_reg = 1;
      this.addDataOrderReg.is_agency = 1;
      this.addDataOrderReg.is_tax_report = 1;
      this.addDataOrderReg.is_open_bank = 1;
      this.addDataOrderReg.is_tax_plate = 1;
      this.addDataOrderReg.is_accum_open = 1;
      this.addDataOrderReg.is_secuity_open = 1;
      this.addDataOrderReg.is_ensure_agent = 1;
      this.addDataOrderReg.is_ensure_hosting = 1;
      this.addDataOrderReg.is_address = 1;
      this.addDataOrderReg.is_industry_change = 1;
      this.addDataOrderReg.is_tax_change = 1;
      this.addDataOrderReg.is_bank_change = 1;
      this.addDataOrderReg.is_secuity_change = 1;
      this.addDataOrderReg.is_accum_change = 1;
      this.addDataOrderReg.is_industry_logout = 1;
      this.addDataOrderReg.is_tax_logout = 1;
      this.addDataOrderReg.is_bank_logout = 1;
      this.addDataOrderReg.is_secuity_logout = 1;
      this.addDataOrderReg.is_accum_logout = 1;
      this.addDataOrderReg.is_licence_logout = 1;
      (this.addDataOrderReg.one_to_one = 1),
        (this.addDataOrderReg.many_to_one = 1),
        (this.addDataOrderReg.spec_accountant = 1),
        (this.addDataOrderReg.msg_attention = 1),
        (this.addDataOrderReg.email_attention = 1),
        (this.addDataOrderReg.public_notice = 1),
        (this.addDataOrderReg.voucher_binding = 1),
        (this.addDataOrderReg.voucher_save = 1),
        (this.addDataOrderReg.total_account = 1),
        (this.addDataOrderReg.voucher_exp = 1),
        (this.addDataOrderReg.tel_seek_acc = 1),
        (this.addDataOrderReg.client_mini = 1),
        (this.addDataOrderReg.financial_report = 1),
        (this.addDataOrderReg.tax_risk = 1),
        (this.addDataOrderReg.license_new = 1),
        (this.addDataOrderReg.license_modify = 1),
        (this.addDataOrderReg.init_build_acc = 1),
        (this.addDataOrderReg.old_tax_import = 1),
        (this.addDataOrderReg.annl_show = 1),
        (this.addDataOrderReg.annl_pay = 1),
        (this.addDataOrderReg.bank_rec_add = 1),
        (this.addDataOrderReg.persionel_salary = 1),
        (this.addDataOrderReg.persionel_calculate = 1),
        (this.addDataOrderReg.tax_withholding = 1),
        (this.addDataOrderReg.tax_return = 1),
        (this.addDataOrderReg.financial_statements = 1),
        (this.addDataOrderReg.add_financial_excel = 1),
        (this.addDataOrderReg.social_host = 1),
        (this.addDataOrderReg.fund_host = 1),
        (this.addDataOrderReg.electric_invoice = 1),
        (this.addDataOrderReg.invoice_manage = 1),
        (this.addDataOrderReg.tax_unlock = 1);
    },
    handleSaveOrderReg() {
      if (!this.upDataOrderReg.order_cate) {
        this.$message.error("订单分类不能为空");
        return;
      }
      if (!this.upDataOrderReg.order_reg_name) {
        this.$message.error("订单类型不能为空");
        return;
      }
      this.$axios
        .post(
          "/api/order_reg/update/" + this.upDataOrderReg.order_reg_id,
          this.upDataOrderReg
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            let index =
              this.pageOptionOrderReg.pageSize *
                (this.pageOptionOrderReg.currentPage - 1) +
              this.upDataOrderReg.index;
            this.optionOrderReg[index].order_cate = this.upDataOrderReg.order_cate;
            this.optionOrderReg[
              index
            ].order_reg_name = this.upDataOrderReg.order_reg_name;
            this.optionOrderReg[
              index
            ].order_include_reg = this.upDataOrderReg.order_include_reg;
            this.optionOrderReg[index].is_agency = this.upDataOrderReg.is_agency;
            this.optionOrderReg[index].is_tax_report = this.upDataOrderReg.is_tax_report;
            this.optionOrderReg[index].is_open_bank = this.upDataOrderReg.is_open_bank;
            this.optionOrderReg[index].is_tax_plate = this.upDataOrderReg.is_tax_plate;
            this.optionOrderReg[index].is_accum_open = this.upDataOrderReg.is_accum_open;
            this.optionOrderReg[
              index
            ].is_secuity_open = this.upDataOrderReg.is_secuity_open;
            this.optionOrderReg[
              index
            ].is_ensure_agent = this.upDataOrderReg.is_ensure_agent;
            this.optionOrderReg[
              index
            ].is_ensure_hosting = this.upDataOrderReg.is_ensure_hosting;
            this.optionOrderReg[index].is_address = this.upDataOrderReg.is_address;
            this.optionOrderReg[
              index
            ].is_industry_change = this.upDataOrderReg.is_industry_change;
            this.optionOrderReg[index].is_tax_change = this.upDataOrderReg.is_tax_change;
            this.optionOrderReg[
              index
            ].is_bank_change = this.upDataOrderReg.is_bank_change;
            this.optionOrderReg[
              index
            ].is_secuity_change = this.upDataOrderReg.is_secuity_change;
            this.optionOrderReg[
              index
            ].is_accum_change = this.upDataOrderReg.is_accum_change;
            this.optionOrderReg[
              index
            ].is_industry_logout = this.upDataOrderReg.is_industry_logout;
            this.optionOrderReg[index].is_tax_logout = this.upDataOrderReg.is_tax_logout;
            this.optionOrderReg[
              index
            ].is_bank_logout = this.upDataOrderReg.is_bank_logout;
            this.optionOrderReg[
              index
            ].is_secuity_logout = this.upDataOrderReg.is_secuity_logout;
            this.optionOrderReg[
              index
            ].is_accum_logout = this.upDataOrderReg.is_accum_logout;
            this.optionOrderReg[
              index
            ].is_licence_logout = this.upDataOrderReg.is_licence_logout;
            this.optionOrderReg[index].one_to_one = this.upDataOrderReg.one_to_one;
            this.optionOrderReg[index].many_to_one = this.upDataOrderReg.many_to_one;
            this.optionOrderReg[
              index
            ].spec_accountant = this.upDataOrderReg.spec_accountant;
            this.optionOrderReg[index].msg_attention = this.upDataOrderReg.msg_attention;
            this.optionOrderReg[
              index
            ].email_attention = this.upDataOrderReg.email_attention;
            this.optionOrderReg[index].public_notice = this.upDataOrderReg.public_notice;
            this.optionOrderReg[
              index
            ].voucher_binding = this.upDataOrderReg.voucher_binding;
            this.optionOrderReg[index].voucher_save = this.upDataOrderReg.voucher_save;
            this.optionOrderReg[index].total_account = this.upDataOrderReg.total_account;
            this.optionOrderReg[index].voucher_exp = this.upDataOrderReg.voucher_exp;
            this.optionOrderReg[index].tel_seek_acc = this.upDataOrderReg.tel_seek_acc;
            this.optionOrderReg[index].client_mini = this.upDataOrderReg.client_mini;
            this.optionOrderReg[
              index
            ].financial_report = this.upDataOrderReg.financial_report;
            this.optionOrderReg[index].tax_risk = this.upDataOrderReg.tax_risk;
            this.optionOrderReg[index].license_new = this.upDataOrderReg.license_new;
            this.optionOrderReg[
              index
            ].license_modify = this.upDataOrderReg.license_modify;
            this.optionOrderReg[
              index
            ].init_build_acc = this.upDataOrderReg.init_build_acc;
            this.optionOrderReg[
              index
            ].old_tax_import = this.upDataOrderReg.old_tax_import;
            this.optionOrderReg[index].annl_show = this.upDataOrderReg.annl_show;
            this.optionOrderReg[index].annl_pay = this.upDataOrderReg.annl_pay;
            this.optionOrderReg[index].bank_rec_add = this.upDataOrderReg.bank_rec_add;
            this.optionOrderReg[
              index
            ].persionel_salary = this.upDataOrderReg.persionel_salary;
            this.optionOrderReg[
              index
            ].persionel_calculate = this.upDataOrderReg.persionel_calculate;
            this.optionOrderReg[
              index
            ].tax_withholding = this.upDataOrderReg.tax_withholding;
            this.optionOrderReg[index].tax_return = this.upDataOrderReg.tax_return;
            this.optionOrderReg[
              index
            ].financial_statements = this.upDataOrderReg.financial_statements;
            this.optionOrderReg[
              index
            ].add_financial_excel = this.upDataOrderReg.add_financial_excel;
            this.optionOrderReg[index].social_host = this.upDataOrderReg.social_host;
            this.optionOrderReg[index].fund_host = this.upDataOrderReg.fund_host;
            this.optionOrderReg[
              index
            ].electric_invoice = this.upDataOrderReg.electric_invoice;
            this.optionOrderReg[
              index
            ].invoice_manage = this.upDataOrderReg.invoice_manage;
            this.optionOrderReg[index].tax_unlock = this.upDataOrderReg.tax_unlock;
            this.$message.success(data.msg);
            this.saveDrawerOrderReg = false;
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleDeleteOrderReg(index, id) {
      this.handleDeleteSubOrderReg(index, id);
    },
    handleDeleteSubOrderReg(index, id) {
      this.$axios.get("/api/order_reg/delete/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          let idx =
            this.pageOptionOrderReg.pageSize * (this.pageOptionOrderReg.currentPage - 1) +
            index;
          this.optionOrderReg.splice(idx, 1);
          this.pageOptionOrderReg.total = this.optionOrderReg.length;
          if (index === 0) this.prePage(this.pageOptionOrderReg, "OrderReg");
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleSizeChangeOrderReg(val) {
      this.pageOptionOrderReg.pageSize = val;
    },
    handleCurrentChangeOrderReg(val) {
      this.pageOptionOrderReg.currentPage = val;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    handleSaveDrawerClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
  mounted() {
    this.getDataOrderReg();
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
@import '~styles/icon.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-drawer__wrapper >>> .el-drawer__header span
  color: #4c87fc
  font-size 0.36rem
  font-weight 400
.service_manage
  marginLeft()
.mt-10
  margin-top: .2rem
.tr
  text-align: right
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  overflow-y auto
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
  .el-select
    width: 100%
.service_manage >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.addCon
  padding: .2rem
  text-align: right
.count_style
  display: inline-block
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.label-height
  line-height: 28px
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/setting_panel/OrderTypeList.vue